<template>
  <dialog-scroll-lock
    v-bind="$attrs"
    v-on="$listeners"
    :content-class="$attrs['content-class'] + (loading ? ' hidden' : '')"
  >
    <dialog-scroll-lock
      v-if="loading"
      fullscreen
      :transition="null"
      :value="true"
      @input="v => $emit('input', v)"
    >
      <div class="fill-height d-flex justify-center align-center" @click="$emit('input', false)">
        <v-progress-circular color="white" indeterminate />
      </div>
    </dialog-scroll-lock>
    <slot></slot>
  </dialog-scroll-lock>
</template>

<style>
.hidden {
  display: none;
}
</style>

<script>
export default {
  name: 'dialog-scroll-lock-loader',
  props: [ 'loading' ]
}
</script>
